import {
  GET_META_TAGS,
  GET_META_TAGS_FAILED,
  GET_META_TAGS_SUCCESS,
  CREATE_META_TAG,
  CREATE_META_TAG_SUCCESS,
  CREATE_META_TAG_FAILED,
  RESET_META_TAGS,
  OPEN_DELETE_TAG_MODAL,
  HIDE_DELETE_TAG_MODAL,
  DELETE_META_TAG,
  DELETE_META_TAG_SUCCESS,
  DELETE_META_TAG_FAILED,
  UPDATE_META_TAG,
  UPDATE_META_TAG_SUCCESS,
  UPDATE_META_TAG_FAILED,
  OPEN_MERGE_TAGS_MODAL,
  HIDE_MERGE_TAGS_MODAL,
  MERGE_META_TAGS,
  MERGE_META_TAGS_SUCCESS,
  MERGE_META_TAGS_FAILED,
  GET_TAG,
  GET_TAG_SUCCESS,
  GET_TAG_FAILED,
  RESET_TAG,
} from "./actionTypes"

export const getMetaTags = params => ({
  type: GET_META_TAGS,
  payload: params,
})

export const getMetaTagsSuccess = response => ({
  type: GET_META_TAGS_SUCCESS,
  payload: response,
})

export const getMetaTagsFailed = error => ({
  type: GET_META_TAGS_FAILED,
  payload: error,
})

export const resetMetaTags = () => ({
  type: RESET_META_TAGS,
  payload: {},
})

export const createMetaTag = params => ({
  type: CREATE_META_TAG,
  payload: params,
})

export const createMetaTagSuccess = response => ({
  type: CREATE_META_TAG_SUCCESS,
  payload: response,
})

export const createMetaTagFailed = error => ({
  type: CREATE_META_TAG_FAILED,
  payload: error,
})

export const openDeleteTagModal = () => ({
  type: OPEN_DELETE_TAG_MODAL,
  payload: {},
})

export const hideDeleteTagModal = () => ({
  type: HIDE_DELETE_TAG_MODAL,
  payload: {},
})

export const deleteMetaTag = params => ({
  type: DELETE_META_TAG,
  payload: params,
})

export const deleteMetaTagSuccess = response => ({
  type: DELETE_META_TAG_SUCCESS,
  payload: response,
})

export const deleteMetaTagFailed = error => ({
  type: DELETE_META_TAG_FAILED,
  payload: error,
})

export const updateMetaTag = params => ({
  type: UPDATE_META_TAG,
  payload: params,
})

export const updateMetaTagSuccess = response => ({
  type: UPDATE_META_TAG_SUCCESS,
  payload: response,
})

export const updateMetaTagFailed = error => ({
  type: UPDATE_META_TAG_FAILED,
  payload: error,
})

export const openMergeTagsModal = () => ({
  type: OPEN_MERGE_TAGS_MODAL,
  payload: {},
})

export const hideMergeTagsModal = () => ({
  type: HIDE_MERGE_TAGS_MODAL,
  payload: {},
})

export const mergeMetaTags = params => ({
  type: MERGE_META_TAGS,
  payload: params,
})

export const mergeMetaTagsSuccess = response => ({
  type: MERGE_META_TAGS_SUCCESS,
  payload: response,
})

export const mergeMetaTagsFailed = error => ({
  type: MERGE_META_TAGS_FAILED,
  payload: error,
})

export const getTag = params => ({
  type: GET_TAG,
  payload: params,
})

export const getTagSuccess = response => ({
  type: GET_TAG_SUCCESS,
  payload: response,
})

export const getTagFailed = error => ({
  type: GET_TAG_FAILED,
  payload: error,
})

export const resetTag = () => ({
  type: RESET_TAG,
  payload: {},
})
